import { useState, useEffect } from 'react';
import useSWR from 'swr';
import { getEntityImage } from '@/studbook/api';
import {
  DocumentImageSize,
  DocumentTypeCode,
  EApiKey,
} from '@/studbook/constants';
import { usePrivate } from '@/components/private';

export default function useImageFromEntity(
  entityGuid: string,
  orgId: string,
  size: DocumentImageSize,
  type: DocumentTypeCode = DocumentTypeCode.Image,
) {
  const { token: accessToken } = usePrivate();

  const {
    data: imgData,
    isLoading: isLoadingImg,
    error: imgError,
  } = useSWR(
    () =>
      !!entityGuid && !!orgId
        ? [EApiKey.GET_ENTITY_IMAGE, entityGuid, accessToken]
        : false,
    () => getEntityImage(entityGuid, type, size, accessToken!, orgId),
  );

  const [imgUrl, setImgUrl] = useState('');

  useEffect(() => {
    return () => {
      if (imgUrl) {
        URL.revokeObjectURL(imgUrl);
      }
    };
  }, [imgUrl]);

  useEffect(() => {
    if (imgData instanceof Blob && imgData.size > 0) {
      const objectUrl = URL.createObjectURL(imgData);
      setImgUrl(objectUrl);
    }
  }, [imgData]);

  return {
    imgUrl,
    imgError,
    isLoadingImg,
  };
}
